import getExistingCLPInfo from './getExistingCLPInfo';
import updateItemCLPInfoInMailStore from '../../actions/clp/updateItemCLPInfoInMailStore';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { ClientItem } from 'owa-mail-store';
import getCLPLabelExtendedPropertyValue from './getCLPLabelExtendedPropertyValue';
import { isFeatureEnabled } from 'owa-feature-flags';
import { pendingLoadLabelPromise } from '../../actions/clp/loadCLPUserLabels';

export default function updateItemCLPInfo(
    item: ClientItem,
    extendedProperty?: ExtendedPropertyType
) {
    if (isFeatureEnabled('cmp-clp')) {
        if (pendingLoadLabelPromise) {
            pendingLoadLabelPromise.then(() => {
                parseAndUpdateCLPLabelStringInMailStore(item, extendedProperty);
            });
        } else {
            parseAndUpdateCLPLabelStringInMailStore(item, extendedProperty);
        }
    }
}

function parseAndUpdateCLPLabelStringInMailStore(
    item?: ClientItem,
    extendedProperty?: ExtendedPropertyType
) {
    if (item && !item.itemCLPInfo) {
        let itemCLPLabelString = '';
        if (extendedProperty) {
            itemCLPLabelString = extendedProperty.Value;
        } else {
            itemCLPLabelString = getCLPLabelExtendedPropertyValue(item);
        }
        updateItemCLPInfoInMailStore(item, getExistingCLPInfo(itemCLPLabelString));
    }
}
